import { render, staticRenderFns } from "./CreateRelapseView.vue?vue&type=template&id=54cd1dbb&"
import script from "./CreateRelapseView.vue?vue&type=script&lang=js&"
export * from "./CreateRelapseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports